// @mui material components
import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

import { SIDENAV_MINI_WIDTH_PX, SIDENAV_WIDTH_PX } from "../../lib/ui/sidenavLayout";

export default styled(Drawer)(({ theme, ownerState }: any) => {
  const { palette, boxShadows, transitions, breakpoints, functions } = theme;
  const { transparentSidenav = false, whiteSidenav = false, miniSidenav = false, darkMode = false } = ownerState || {};

  const sidebarWidth = SIDENAV_WIDTH_PX;
  const { transparent, white, background } = palette;
  const { xxl } = boxShadows;
  const { pxToRem } = functions;

  let backgroundValue = background.sidenav || (darkMode ? background.default : white.main);

  if (transparentSidenav) {
    backgroundValue = transparent.main;
  } else if (whiteSidenav) {
    backgroundValue = white.main;
  }

  // styles for the sidenav when miniSidenav={false}
  const drawerOpenStyles = () => ({
    position: "fixed !important",
    top: "0 !important",
    left: "0 !important",
    height: "100vh !important",
    width: `${sidebarWidth}px !important`,
    background: `${backgroundValue} !important`,
    backgroundColor: `${backgroundValue} !important`,
    transform: "translateX(0)",
    zIndex: 1200,
    overflowY: "auto",
    overflowX: "hidden",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    [breakpoints.up("lg")]: {
      boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: sidebarWidth,
      transform: "translateX(0)",
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.enteringScreen,
      }),
    },
  });

  // styles for the sidenav when miniSidenav={true}
  const drawerCloseStyles = () => ({
    position: "fixed !important",
    top: "0 !important",
    left: "0 !important",
    height: "100vh !important",
    background: `${backgroundValue} !important`,
    backgroundColor: `${backgroundValue} !important`,
    transform: `translateX(${pxToRem(-320)})`,
    zIndex: 1200,
    overflowY: "auto",
    overflowX: "hidden",
    transition: transitions.create("transform", {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),

    // Hide completely on mobile devices (below lg breakpoint)
    [breakpoints.down("lg")]: {
      transform: `translateX(${pxToRem(-320)}) !important`,
      visibility: "hidden",
      opacity: 0,
    },

    // Mini mode on tablet and desktop devices
    [breakpoints.up("lg")]: {
      boxShadow: transparentSidenav ? "none" : xxl,
      marginBottom: transparentSidenav ? 0 : "inherit",
      left: "0",
      width: `${SIDENAV_MINI_WIDTH_PX}px`,
      overflowX: "hidden",
      transform: "translateX(0)",
      visibility: "visible",
      opacity: 1,
      transition: transitions.create(["width", "background-color"], {
        easing: transitions.easing.sharp,
        duration: transitions.duration.shorter,
      }),
      "& .MuiListItemText-root": {
        display: "none",
      },
      "& .MuiListItem-root": {
        paddingLeft: 0,
        paddingRight: 0,
      },
      "& .MuiListItemIcon-root": {
        minWidth: "28px !important",
      },
    },
  });

  return {
    position: "fixed",
    zIndex: 1200,
    
    // Hide completely on mobile devices
    [breakpoints.down("lg")]: {
      display: miniSidenav ? "none" : "block",
    },
    
    "& .MuiDrawer-paper": {
      boxShadow: xxl,
      border: "none",

      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),
    },
  };
});
